import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import TYPES from '@/modules/shared/types';
import { EconomicActivityRepository } from '../../domain/repository/economic-activity-repository';
import { EconomicActivityEntity } from '../../domain/entities/economic-activity-entity';

@Injectable()
export default class EconomicActivityFetchRepository implements EconomicActivityRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/catalogs/economic_activities/`;

  findAll(): Promise<Array<EconomicActivityEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
